import { type StoreActionApi } from 'react-sweet-state';

import type { ChatMessageResearchStore } from './types';

type ResetHasReceivedAnswerPartArgs = { messageId: string };

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const resetHasReceivedAnswerPart: (
	args: ResetHasReceivedAnswerPartArgs,
) => ChatMessageResearchStoreAction =
	({ messageId }: { messageId: string }) =>
	({ getState, setState }: StoreActionApi<ChatMessageResearchStore>) => {
		const message = getState()[messageId];
		if (message && message.hasReceivedAnswerPart) {
			setState({
				[messageId]: {
					...message,
					hasReceivedAnswerPart: false,
				},
			});
		}
	};
